import type { MatterArtifactSelectionAttachment } from '@/agent-v2/artifact-selection/types'
import { AgentV2RunPhase } from '@/agent-v2/conversations/store/slice'
import { AgentV2ServerEventType, type MatterArtifactVersionSelection } from '@/agent-v2/store/schemas'
import type { RootState } from '@/store/store'

export function selectMatterArtifactSelectionAttachment(state: RootState, props: { conversationId: string }): MatterArtifactSelectionAttachment | null {
  return state.matterArtifactSelectionState.attachmentsByConversationId[props.conversationId] ?? null
}

/**
 * Resolves semantic ownership for a selected-passage edit from the exact open turn.
 * Editor ranges remain in the transient attachment and are deliberately not reconstructed.
 */
export function selectActiveMatterArtifactSelection(state: RootState, props: { conversationId: string }): MatterArtifactVersionSelection | null {
  const lifecycle = state.agentV2ConversationsState.runLifecycleByConversationId[props.conversationId]
  if (!lifecycle || lifecycle.phase === AgentV2RunPhase.IDLE) return null

  const detail = state.agentV2ConversationsState.details[props.conversationId]
  const activeTurn = lifecycle.turnId
    ? detail?.turns.find((turn) => turn.id === lifecycle.turnId)
    : lifecycle.clientRequestId
    ? detail?.turns.find((turn) => turn.client_request_id === lifecycle.clientRequestId)
    : undefined

  if (activeTurn) {
    if (activeTurn.ended_at !== null) return null
    const userMessage = activeTurn.events.find((event) => event.type === AgentV2ServerEventType.USER_MESSAGE_CREATED)
    return userMessage?.payload.matter_artifact_selection ?? null
  }

  return state.matterArtifactSelectionState.attachmentsByConversationId[props.conversationId]?.selection ?? null
}
